module.exports = __webpack_public_path__ + "img/money_small.999df254.svg";